import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

export interface ISegmentedToggleOption {
  label: string;
  value: string;
}

@Component({
  selector: 'app-segmented-toggle',
  templateUrl: 'segmented-toggle.component.html',
  styleUrls: ['segmented-toggle.component.scss'],
})
export class SegmentedToggleComponent implements OnInit {
  @Input() options: ISegmentedToggleOption[] = [];
  @Input() value: string;
  @Output() valueChange = new EventEmitter<string>();

  constructor() {}

  ngOnInit(): void {}

  onSelect(option: ISegmentedToggleOption): void {
    if (option.value === this.value) return;
    this.valueChange.emit(option.value);
  }
}
